import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'

const propTypes = {
  isActive: PropTypes.bool
}

/**
 * To give nice look on `Vouhcer.is_active`
 * It maps to certain style and pass to `StatusBadge`.
 * @param {boolean} isActive Voucher is_active value
 */
const ActiveBadge = ({ isActive }) => {

  const color = isActive ? 'primary' : 'info'
  const label = isActive ? 'Yes' : 'No'

  return <StatusBadge color={ color } label={ label } />
}

ActiveBadge.propTypes = propTypes

export default ActiveBadge
